import * as tslib_1 from "tslib";
import * as React from 'react';
import { Icon } from '../../Icon';
import { BaseComponent, classNamesFunction } from '../../Utilities';
var getClassNames = classNamesFunction();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardLogoBase = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardLogoBase, _super);
    function DocumentCardLogoBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardLogoBase.prototype.render = function () {
        var _a = this.props, logoIcon = _a.logoIcon, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (React.createElement("div", { className: this._classNames.root },
            React.createElement(Icon, { iconName: logoIcon })));
    };
    return DocumentCardLogoBase;
}(BaseComponent));
export { DocumentCardLogoBase };
//# sourceMappingURL=DocumentCardLogo.base.js.map